import axios from 'axios'

export default {
  getAllVehicleGroups: async ({ commit, rootState }) => {
    commit(
      'app/setLoading',
      { type: 'getAllVehicleGroups', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/vehicle-groups`, config)
        .then(response => {
          commit('setVehicleGroups', response.data)
          commit(
            'app/setLoading',
            { type: 'getAllVehicleGroups', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getAllVehicleGroups', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  async putVehicleGroup({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'putVehicleGroup', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }

      axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/vehicle-groups`,
          { ID: payload.ID, name: payload.name },
          config
        )
        .then(response => {
          commit('setVehicleGroupInVehicleGroupsArray', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(true)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t(
                '$vuetify.VEHICLE_GROUPS.PUT_SUCCESSFUL'
              )
            },
            { root: true }
          )
        })
        .catch(error => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'putVehicleGroup', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  async postVehicleGroup({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postVehicleGroup', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }

      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/vehicle-groups`,
          { name: payload.name },
          config
        )
        .then(response => {
          commit('addVehicleGroupItem', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(true)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t(
                '$vuetify.VEHICLE_GROUPS.POST_SUCCESSFUL'
              )
            },
            { root: true }
          )
        })
        .catch(error => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postVehicleGroup', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  getVehicleGroupLicensePlates: async ({ commit, rootState }, id) => {
    commit(
      'app/setLoading',
      { type: 'getVehicleGroupLicensePlates', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/vehicle-groups/${id}/license-plates`,
          config
        )
        .then(response => {
          commit('setVehicleGroupLicensePlates', response.data)
          commit(
            'app/setLoading',
            { type: 'getVehicleGroupLicensePlates', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getVehicleGroupLicensePlates', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  async postVehicleGroupLicensePlates(
    { commit, dispatch, rootState },
    payload
  ) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postVehicleGroupLicensePlates', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }

      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/vehicle-groups/${payload.vehicleGroupId}/license-plates`,
          {
            licensePlates: payload.licensePlates,
            removePlatesNotInRequest: payload.removePlatesNotInRequest
          },
          config
        )
        .then(async () => {
          await dispatch('getVehicleGroupLicensePlates', payload.vehicleGroupId)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(true)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t(
                '$vuetify.VEHICLE_GROUPS.LICENSE_PLATES_POST_SUCCESSFUL'
              )
            },
            { root: true }
          )
        })
        .catch(error => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postVehicleGroupLicensePlates', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  async putVehicleGroupLicensePlate({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'putVehicleGroupLicensePlate', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }

      axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/vehicle-groups/${payload.vehicleGroupId}/license-plates`,
          { ID: payload.ID, licensePlate: payload.licensePlate },
          config
        )
        .then(response => {
          commit('updateVehicleGroupLicensePlate', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(true)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t(
                '$vuetify.VEHICLE_GROUPS.PUT_SUCCESSFUL'
              )
            },
            { root: true }
          )
        })
        .catch(error => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'putVehicleGroupLicensePlate', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  async deleteVehicleGroupLicensePlate({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'deleteVehicleGroupLicensePlate', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }

      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/vehicle-groups/${payload.vehicleGroupId}/license-plates/delete`,
          { ID: payload.ID },
          config
        )
        .then(() => {
          commit('removeLicensePlateById', payload.ID)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(true)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t(
                '$vuetify.VEHICLE_GROUPS.DELETE_SUCCESSFUL'
              )
            },
            { root: true }
          )
        })
        .catch(error => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'deleteVehicleGroupLicensePlate', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  }
}
